document.addEventListener('DOMContentLoaded', function () {
  var filterToggle = document.querySelector('[data-filter-toggle]');
  if (filterToggle) {
    filterToggle.addEventListener('click', function () {
      var filters = document.querySelector('.filters');
      if (!filters) return;
      var open = filters.classList.toggle('is-open');
      filterToggle.textContent = open ? 'Filtreyi kapat' : 'Filtrele';
    });
  }

  var announce = document.querySelector('[data-announce]');
  if (announce) {
    var lines = [
      '1.000 TL ÜZERİ SİPARİŞLERDE KARGO ÜCRETSİZ',
      'TÜM SİPARİŞLER 1 İŞ GÜNÜ İÇİNDE KARGODA',
      'KAPIDA ÖDEME İLE SİPARİŞ',
      'ŞEFFAF KARGO İLE GÖNDERİM'
    ];
    var index = 0;
    setInterval(function () {
      announce.style.opacity = '0';
      setTimeout(function () {
        index = (index + 1) % lines.length;
        announce.textContent = lines[index];
        announce.style.opacity = '1';
      }, 350);
    }, 3200);
  }

  var track = document.querySelector('[data-shelf-track]');
  if (track) {
    var offset = 0;
    var half = 0;
    function measureShelf() { half = track.scrollWidth / 2; }
    measureShelf();
    window.addEventListener('resize', measureShelf);
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function shelfStep() {
      var card = track.children[0];
      if (!card) return 0;
      return card.getBoundingClientRect().width + 18;
    }
    function paintShelf() {
      if (!half) measureShelf();
      if (half > 0) offset = ((offset % half) + half) % half;
      track.style.transform = 'translate3d(' + (-offset).toFixed(2) + 'px,0,0)';
    }
    document.querySelectorAll('[data-shelf]').forEach(function (button) {
      button.addEventListener('click', function () {
        offset += Number(button.getAttribute('data-shelf')) * shelfStep();
        paintShelf();
      });
    });
    var view = track.parentElement;
    var dragging = false;
    var startX = 0;
    var startOffset = 0;
    var pauseUntil = 0;
    view.addEventListener('touchstart', function (event) {
      dragging = true;
      startX = event.touches[0].clientX;
      startOffset = offset;
    }, { passive: true });
    view.addEventListener('touchmove', function (event) {
      if (!dragging) return;
      offset = startOffset + (startX - event.touches[0].clientX);
      paintShelf();
    }, { passive: true });
    view.addEventListener('touchend', function () {
      dragging = false;
      pauseUntil = performance.now() + 900;
    });
    if (!reduced) {
      var last = performance.now();
      var speed = window.matchMedia('(max-width: 900px)').matches ? 10 : 16;
      (function tick(now) {
        var dt = Math.min(now - last, 40);
        last = now;
        if (!dragging && now >= pauseUntil) offset += speed * dt / 1000;
        paintShelf();
        requestAnimationFrame(tick);
      })(last);
    }
  }

  var slides = Array.prototype.slice.call(document.querySelectorAll('.hero-slide'));
  function showSlide(step) {
    if (slides.length < 2) return;
    var current = slides.findIndex(function (slide) { return slide.classList.contains('is-on'); });
    var next = (current + step + slides.length) % slides.length;
    slides.forEach(function (slide, i) { slide.classList.toggle('is-on', i === next); });
  }
  document.querySelectorAll('[data-hero]').forEach(function (button) {
    button.addEventListener('click', function () { showSlide(Number(button.getAttribute('data-hero'))); });
  });
  if (slides.length > 1) setInterval(function () { showSlide(1); }, 5000);

  var menu = document.querySelector('[data-drawer]');
  document.querySelector('[data-menu-open]')?.addEventListener('click', function () {
    if (menu) menu.hidden = false;
  });
  document.querySelectorAll('[data-menu-close]').forEach(function (button) {
    button.addEventListener('click', function () { if (menu) menu.hidden = true; });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && menu) menu.hidden = true;
  });

  var cookie = document.getElementById('cookie');
  if (cookie && !localStorage.getItem('cookie-ok')) cookie.hidden = false;
  var accept = document.getElementById('cookie-accept');
  if (accept) accept.addEventListener('click', function () {
    localStorage.setItem('cookie-ok', '1');
    cookie.hidden = true;
  });

  var discountApply = document.querySelector('[data-discount-apply]');
  var discountInput = document.querySelector('[data-discount]');
  if (discountApply && discountInput) {
    discountApply.addEventListener('click', function () {
      var code = discountInput.value.trim();
      if (!code) { discountInput.focus(); return; }
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    });
    discountInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        discountApply.click();
      }
    });
  }

  document.querySelectorAll('.qty').forEach(function (box) {
    var input = box.querySelector('input');
    box.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = Math.max(0, Number(input.value) + Number(btn.getAttribute('data-qty')));
        input.value = String(next);
        var form = box.closest('form');
        if (form) form.submit();
      });
    });
  });

  document.querySelectorAll('[data-filter] input').forEach(function (input) {
    input.addEventListener('change', filterProducts);
  });

  document.querySelectorAll('.swatch').forEach(function (btn) {
    function apply() {
      var card = btn.closest('.card');
      var img = card.querySelector('.card-photo');
      var src = btn.getAttribute('data-src');
      if (img && src) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = src;
      }
      var id = card.querySelector('[name="id"]');
      if (id) id.value = btn.getAttribute('data-id');
      var media = card.querySelector('.card-media');
      if (media && btn.getAttribute('data-id')) {
        var url = new URL(media.href, window.location.origin);
        url.searchParams.set('variant', btn.getAttribute('data-id'));
        media.href = url.pathname + url.search;
      }
      card.querySelectorAll('.swatch').forEach(function (el) { el.classList.toggle('is-on', el === btn); });
    }
    btn.addEventListener('mouseenter', apply);
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      apply();
    });
  });

  var data = document.getElementById('variant-json');
  if (!data) return;
  var variants = JSON.parse(data.textContent);
  var chosen = {};
  var current = variants.find(function (v) { return v.available; }) || variants[0];
  if (current) {
    chosen[1] = current.option1;
    chosen[2] = current.option2;
    chosen[3] = current.option3;
  }
  document.querySelectorAll('.size').forEach(function (button) {
    button.addEventListener('click', function () {
      var pos = button.getAttribute('data-option');
      chosen[pos] = button.getAttribute('data-value');
      document.querySelectorAll('.size[data-option="' + pos + '"]').forEach(function (el) {
        el.classList.toggle('is-on', el === button);
      });
      var match = variants.find(function (v) {
        return (!chosen[1] || v.option1 === chosen[1]) && (!chosen[2] || v.option2 === chosen[2]) && (!chosen[3] || v.option3 === chosen[3]);
      });
      if (!match) return;
      var id = document.querySelector('[data-variant-id]');
      if (id) id.value = match.id;
      var price = document.querySelector('[data-price]');
      if (price) {
        var html = '';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          var pct = Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price);
          html += '<span class="discount-badge">%' + pct + '</span><s>' + formatMoney(match.compare_at_price) + '</s> ';
        }
        html += '<span>' + formatMoney(match.price) + '</span>';
        price.innerHTML = html;
      }
      var stock = document.querySelector('[data-stock]');
      if (stock) {
        stock.textContent = match.available ? 'Stokta' : 'Tükendi';
      }
      if (match.featured_image && match.featured_image.src) {
        showPhoto(match.featured_image.src);
        var file = match.featured_image.src.split('?')[0].split('/').pop();
        document.querySelectorAll('.thumb').forEach(function (el) {
          el.classList.toggle('is-on', (el.getAttribute('data-src') || '').indexOf(file) !== -1);
        });
      }
      var buy = document.querySelector('.buy');
      if (buy) buy.disabled = !match.available;
    });
  });
});

function filterProducts() {
  var sizes = checked('size');
  var colors = checked('color');
  var aliases = {
    siyah: ['siyah', 'black'],
    beyaz: ['beyaz', 'white'],
    gri: ['gri', 'gray', 'grey'],
    lacivert: ['lacivert', 'navy']
  };
  document.querySelectorAll('[data-product-grid] .card').forEach(function (card) {
    var sizesText = (card.getAttribute('data-sizes') || '').toLowerCase();
    var colorsText = (card.getAttribute('data-colors') || '').toLowerCase();
    var sizeOk = !sizes.length || sizes.some(function (s) {
      var name = s.toLowerCase();
      var list = sizesText.split(',').map(function (part) { return part.trim(); });
      if (name === 'xxl') return list.indexOf('xxl') !== -1 || list.indexOf('2xl') !== -1;
      return list.indexOf(name) !== -1;
    });
    var colorOk = !colors.length || colors.some(function (c) {
      var words = aliases[c.toLowerCase()] || [c.toLowerCase()];
      return words.some(function (word) { return colorsText.indexOf(word) !== -1; });
    });
    card.classList.toggle('is-hidden', !(sizeOk && colorOk));
  });
}

function checked(name) {
  return Array.prototype.map.call(document.querySelectorAll('[data-filter="' + name + '"] input:checked'), function (el) {
    return el.value;
  });
}

function formatMoney(cents) {
  return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(cents / 100);
}

function fitStage(img) {
  var stageEl = document.querySelector('.stage');
  if (!stageEl || !img || !img.naturalWidth) return;
  stageEl.style.aspectRatio = img.naturalWidth + ' / ' + img.naturalHeight;
}

function showPhoto(src, dir) {
  var img = document.getElementById('stage-img');
  var stageEl = document.querySelector('.stage');
  if (!img || img.tagName !== 'IMG' || !src) return;
  var file = src.split('?')[0].split('/').pop();
  if ((img.getAttribute('src') || '').indexOf(file) !== -1) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!stageEl || reduce || !dir) {
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = src;
    img.style.transform = '';
    fitStage(img);
    return;
  }
  var incoming = document.createElement('img');
  incoming.alt = img.alt || '';
  incoming.src = src;
  incoming.style.transform = 'translateX(' + (dir < 0 ? '-100%' : '100%') + ')';
  stageEl.appendChild(incoming);
  incoming.offsetWidth;
  img.style.transition = 'transform .42s cubic-bezier(.22,.61,.36,1)';
  incoming.style.transition = 'transform .42s cubic-bezier(.22,.61,.36,1)';
  img.style.transform = 'translateX(' + (dir < 0 ? '100%' : '-100%') + ')';
  incoming.style.transform = 'translateX(0)';
  var done = false;
  function finish() {
    if (done) return;
    done = true;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = src;
    img.style.transition = 'none';
    img.style.transform = '';
    fitStage(img);
    if (incoming.parentNode) incoming.remove();
  }
  incoming.addEventListener('transitionend', finish);
  setTimeout(finish, 480);
}

function selectThumb(thumb, dir) {
  if (!thumb) return;
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.thumb'));
  var current = thumbs.findIndex(function (el) { return el.classList.contains('is-on'); });
  var next = thumbs.indexOf(thumb);
  if (dir == null) dir = next >= current ? 1 : -1;
  showPhoto(thumb.getAttribute('data-src'), dir);
  thumbs.forEach(function (el) { el.classList.remove('is-on'); });
  thumb.classList.add('is-on');
  var file = (thumb.getAttribute('data-src') || '').split('?')[0].split('/').pop();
  var data = document.getElementById('variant-json');
  if (!data || !file) return;
  var match = JSON.parse(data.textContent).find(function (v) {
    return v.featured_image && v.featured_image.src && v.featured_image.src.indexOf(file) !== -1;
  });
  if (!match) return;
  var colorBtn = document.querySelector('.size[data-option="1"][data-value="' + match.option1 + '"]');
  if (colorBtn && !colorBtn.classList.contains('is-on')) colorBtn.click();
}

var stageImg = document.getElementById('stage-img');
if (stageImg && stageImg.tagName === 'IMG') {
  if (stageImg.complete) fitStage(stageImg);
  stageImg.addEventListener('load', function () { fitStage(stageImg); });
}

document.querySelectorAll('.thumb').forEach(function (thumb) {
  thumb.addEventListener('click', function () { selectThumb(thumb); });
});

var warmCache = {};
function warm(src) {
  if (!src || warmCache[src]) return;
  var im = new Image();
  im.decoding = 'async';
  im.src = src;
  warmCache[src] = im;
}
function thumbList() {
  return Array.prototype.slice.call(document.querySelectorAll('.thumb'));
}
function neighborThumb(dir) {
  var thumbs = thumbList();
  if (thumbs.length < 2) return null;
  var current = thumbs.findIndex(function (el) { return el.classList.contains('is-on'); });
  if (current < 0) current = 0;
  var next = current + dir;
  if (next < 0) next = thumbs.length - 1;
  if (next >= thumbs.length) next = 0;
  return thumbs[next];
}
thumbList().forEach(function (el) { warm(el.getAttribute('data-src')); });

var stage = document.querySelector('.stage');
if (stage) {
  var swipeX = 0;
  var swipeY = 0;
  var dragging = false;
  var ghost = null;
  var dragDir = 1;
  var stageWidth = 1;
  stage.addEventListener('touchstart', function (e) {
    swipeX = e.changedTouches[0].clientX;
    swipeY = e.changedTouches[0].clientY;
    dragging = false;
    stageWidth = stage.offsetWidth || 1;
    if (ghost) { ghost.remove(); ghost = null; }
    var prev = neighborThumb(-1);
    var next = neighborThumb(1);
    if (prev) warm(prev.getAttribute('data-src'));
    if (next) warm(next.getAttribute('data-src'));
  }, { passive: true });
  stage.addEventListener('touchmove', function (e) {
    var dx = e.changedTouches[0].clientX - swipeX;
    var dy = e.changedTouches[0].clientY - swipeY;
    var img = document.getElementById('stage-img');
    if (!img) return;
    if (!dragging) {
      if (Math.abs(dx) < 5 || Math.abs(dy) > Math.abs(dx)) return;
      var thumb = neighborThumb(dx < 0 ? 1 : -1);
      if (!thumb) return;
      dragging = true;
      dragDir = dx < 0 ? 1 : -1;
      ghost = document.createElement('img');
      ghost.alt = '';
      ghost.src = thumb.getAttribute('data-src');
      ghost.style.transition = 'none';
      img.style.transition = 'none';
      stage.appendChild(ghost);
    }
    if (!ghost) return;
    if (e.cancelable) e.preventDefault();
    var shift = dragDir < 0 ? -stageWidth : stageWidth;
    img.style.transform = 'translate3d(' + dx + 'px,0,0)';
    ghost.style.transform = 'translate3d(' + (dx + shift) + 'px,0,0)';
  }, { passive: false });
  stage.addEventListener('touchend', function (e) {
    var dx = e.changedTouches[0].clientX - swipeX;
    var dy = e.changedTouches[0].clientY - swipeY;
    var img = document.getElementById('stage-img');
    var width = stageWidth;
    if (dragging && ghost && img) {
      var commit = Math.abs(dx) > 24;
      var thumbs = thumbList();
      var current = thumbs.findIndex(function (el) { return el.classList.contains('is-on'); });
      if (current < 0) current = 0;
      img.style.transition = 'transform .18s linear';
      ghost.style.transition = 'transform .18s linear';
      if (commit) {
        img.style.transform = 'translate3d(' + (dragDir < 0 ? width : -width) + 'px,0,0)';
        ghost.style.transform = 'translate3d(0,0,0)';
        var next = current + dragDir;
        if (next < 0) next = thumbs.length - 1;
        if (next >= thumbs.length) next = 0;
        setTimeout(function () {
          selectThumb(thumbs[next], 0);
          if (ghost) { ghost.remove(); ghost = null; }
          img.style.transition = 'none';
          img.style.transform = '';
        }, 180);
      } else {
        img.style.transform = 'translate3d(0,0,0)';
        ghost.style.transform = 'translate3d(' + (dragDir < 0 ? -width : width) + 'px,0,0)';
        setTimeout(function () {
          if (ghost) { ghost.remove(); ghost = null; }
          img.style.transition = 'none';
        }, 180);
      }
      dragging = false;
      return;
    }
    if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.thumb'));
    if (thumbs.length < 2) return;
    var current = thumbs.findIndex(function (el) { return el.classList.contains('is-on'); });
    if (current < 0) current = 0;
    var step = dx < 0 ? 1 : -1;
    var next = current + step;
    if (next < 0) next = thumbs.length - 1;
    if (next >= thumbs.length) next = 0;
    selectThumb(thumbs[next], step);
  }, { passive: true });
}

var fitBtn = document.querySelector('[data-fit]');
if (fitBtn) {
  fitBtn.addEventListener('click', function () {
    var kg = Number(document.querySelector('[data-weight]').value);
    var size = '';
    if (kg > 0 && kg < 65) size = 'S';
    else if (kg < 75) size = 'M';
    else if (kg < 85) size = 'L';
    else if (kg < 95) size = 'XL';
    else if (kg <= 150) size = '2XL';
    var out = document.querySelector('[data-fit-result]');
    if (!size) { out.textContent = 'Kilonu kilogram olarak yaz.'; return; }
    out.textContent = 'Önerilen beden: ' + size;
    var button = document.querySelector('.size[data-value="' + size + '"]');
    if (button) button.click();
  });
}

var modal = document.getElementById('wheel-modal');
var canvas = document.getElementById('wheel');
var prizes = [
  { label: '50 TL', code: 'CEVIR50', color: '#ff4ad8', ink: '#111' },
  { label: 'TEKRAR', code: '', color: '#141414', ink: '#fff' },
  { label: '100 TL', code: 'CEVIR100', color: '#7dff6a', ink: '#111' },
  { label: '150 TL', code: 'CEVIR150', color: '#8b6bff', ink: '#fff' },
  { label: 'KARGO', code: 'CEVIRKARGO', color: '#3ecbff', ink: '#111' },
  { label: 'TEKRAR', code: '', color: '#1a1030', ink: '#fff' },
  { label: '200 TL', code: 'CEVIR200', color: '#ffe14a', ink: '#111' },
  { label: '75 TL', code: 'CEVIR75', color: '#ff7a3c', ink: '#111' }
];
if (modal && canvas && !sessionStorage.getItem('wheel-closed')) {
  setTimeout(function () { modal.hidden = false; }, 700);
  drawWheel(0);
}
document.querySelector('[data-wheel-close]')?.addEventListener('click', function () {
  modal.hidden = true;
  sessionStorage.setItem('wheel-closed', '1');
});
var spinning = false;
document.getElementById('wheel-form')?.addEventListener('submit', function (event) {
  event.preventDefault();
  if (spinning) return;
  spinning = true;
  var index = Math.floor(Math.random() * prizes.length);
  var slice = (Math.PI * 2) / prizes.length;
  var turns = 6 * Math.PI * 2;
  var target = turns + (Math.PI * 1.5) - (index * slice + slice / 2);
  var start = performance.now();
  var button = event.target.querySelector('.spin-btn');
  button.disabled = true;
  function frame(now) {
    var t = Math.min(1, (now - start) / 4200);
    var ease = 1 - Math.pow(1 - t, 3);
    drawWheel(target * ease);
    if (t < 1) requestAnimationFrame(frame);
    else finishSpin(index, button);
  }
  requestAnimationFrame(frame);
});

function drawWheel(rotation) {
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  var c = canvas.width / 2;
  var slice = (Math.PI * 2) / prizes.length;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.beginPath();
  ctx.arc(c, c, c - 2, 0, Math.PI * 2);
  ctx.fillStyle = '#111';
  ctx.fill();
  prizes.forEach(function (prize, i) {
    ctx.beginPath();
    ctx.moveTo(c, c);
    ctx.fillStyle = prize.color;
    ctx.arc(c, c, c - 10, rotation + i * slice, rotation + (i + 1) * slice);
    ctx.fill();
    var angle = rotation + i * slice + slice / 2;
    var norm = ((angle % (Math.PI * 2)) + Math.PI * 2) % (Math.PI * 2);
    var flip = norm > Math.PI / 2 && norm < Math.PI * 1.5;
    ctx.save();
    ctx.translate(c, c);
    ctx.rotate(angle + (flip ? Math.PI : 0));
    ctx.fillStyle = prize.ink;
    ctx.font = '700 15px Poppins, sans-serif';
    ctx.textAlign = flip ? 'left' : 'right';
    ctx.fillText(prize.label, flip ? -(c - 58) : c - 58, 5);
    ctx.restore();
  });
  ctx.beginPath();
  ctx.arc(c, c, 46, 0, Math.PI * 2);
  ctx.fillStyle = '#041433';
  ctx.fill();
}

function finishSpin(index, button) {
  var prize = prizes[index];
  var result = document.querySelector('[data-wheel-result]');
  if (!prize.code) result.textContent = 'Bu tur boş. Bir kez daha çevirebilirsin.';
  else result.textContent = prize.label + ' kazandın. Kod: ' + prize.code;
  button.disabled = false;
  spinning = prize.code !== '';
  if (prize.code) button.disabled = true;
}

function applyBrandPick(kind, brand) {
  var want = (brand || '').toLocaleLowerCase('tr');
  document.querySelectorAll('.card[data-kind]').forEach(function (card) {
    var kindOk = !kind || card.getAttribute('data-kind') === kind;
    var have = (card.getAttribute('data-brand') || '').toLocaleLowerCase('tr');
    var brandOk = !want || have === want;
    card.classList.toggle('is-hidden', !(kindOk && brandOk));
  });
  document.querySelectorAll('.brand-head').forEach(function (head) {
    var grid = head.nextElementSibling;
    var any = grid && grid.querySelector('.card[data-kind]:not(.is-hidden)');
    head.classList.toggle('is-hidden', !any);
    if (grid) grid.classList.toggle('is-hidden', !any);
  });
  var visible = document.querySelectorAll('.card[data-kind]:not(.is-hidden)').length;
  var note = document.querySelector('[data-brand-empty]');
  if (note) note.hidden = visible > 0;
  document.querySelectorAll('[data-brand-pick]').forEach(function (link) {
    var on = (link.getAttribute('data-kind') || '') === (kind || '') && (link.getAttribute('data-brand') || '') === (brand || '');
    link.classList.toggle('is-on', on);
  });
}

document.addEventListener('click', function (event) {
  var link = event.target.closest('[data-brand-pick]');
  if (!link || !document.querySelector('.card[data-kind]')) return;
  event.preventDefault();
  applyBrandPick(link.getAttribute('data-kind') || '', link.getAttribute('data-brand') || '');
});

var brandParams = new URLSearchParams(location.search);
if (document.querySelector('.card[data-kind]') && (brandParams.has('tur') || brandParams.has('marka'))) {
  applyBrandPick(brandParams.get('tur') || '', brandParams.get('marka') || '');
}

(function () {
  var open = document.querySelector('.tryon-open');
  var modal = document.querySelector('.tryon');
  if (!open || !modal) return;
  var fileInput = modal.querySelector('[data-tryon-file]');
  var canvas = modal.querySelector('[data-tryon-canvas]');
  var sizeInput = modal.querySelector('[data-tryon-size]');
  var hint = modal.querySelector('.tryon-hint');
  var sizeLabel = modal.querySelector('.tryon-size');
  var ctx = canvas.getContext('2d');
  var userImg = null;
  var garment = null;
  var offsetX = 0;
  var offsetY = 0;
  var drag = null;

  function productSrc() {
    var img = document.getElementById('stage-img');
    if (!img || img.tagName !== 'IMG') return '';
    return img.currentSrc || img.src;
  }

  function loadImage(src, cors) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      if (cors) img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = reject;
      img.src = src;
    });
  }

  function knockWhite(img) {
    var c = document.createElement('canvas');
    c.width = img.naturalWidth;
    c.height = img.naturalHeight;
    var g = c.getContext('2d');
    g.drawImage(img, 0, 0);
    var frame = g.getImageData(0, 0, c.width, c.height);
    var p = frame.data;
    var w = c.width;
    var h = c.height;
    for (var i = 0; i < p.length; i += 4) {
      var max = Math.max(p[i], p[i + 1], p[i + 2]);
      var min = Math.min(p[i], p[i + 1], p[i + 2]);
      if (max > 236 && max - min < 18) p[i + 3] = 0;
    }
    for (var pass = 0; pass < 2; pass++) {
      var copy = new Uint8ClampedArray(p);
      for (var y = 1; y < h - 1; y++) {
        for (var x = 1; x < w - 1; x++) {
          var idx = (y * w + x) * 4 + 3;
          if (!copy[idx]) continue;
          var empty = 0;
          if (!copy[idx - 4]) empty++;
          if (!copy[idx + 4]) empty++;
          if (!copy[idx - w * 4]) empty++;
          if (!copy[idx + w * 4]) empty++;
          if (empty) p[idx] = Math.round(copy[idx] * (1 - empty * 0.22));
        }
      }
    }
    var minX = w, minY = h, maxX = 0, maxY = 0;
    for (var yy = 0; yy < h; yy++) {
      for (var xx = 0; xx < w; xx++) {
        if (p[(yy * w + xx) * 4 + 3] > 12) {
          if (xx < minX) minX = xx;
          if (yy < minY) minY = yy;
          if (xx > maxX) maxX = xx;
          if (yy > maxY) maxY = yy;
        }
      }
    }
    g.putImageData(frame, 0, 0);
    if (maxX <= minX || maxY <= minY) return c;
    var cut = document.createElement('canvas');
    cut.width = maxX - minX + 1;
    cut.height = maxY - minY + 1;
    cut.getContext('2d').drawImage(c, minX, minY, cut.width, cut.height, 0, 0, cut.width, cut.height);
    return cut;
  }

  var pose = null;
  var landmarker = null;

  function ensurePose() {
    if (landmarker) return Promise.resolve(landmarker);
    return import('https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14/vision_bundle.mjs').then(function (vision) {
      return vision.FilesetResolver.forVisionTasks('https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14/wasm').then(function (files) {
        return vision.PoseLandmarker.createFromOptions(files, {
          baseOptions: { modelAssetPath: 'https://storage.googleapis.com/mediapipe-models/pose_landmarker/pose_landmarker_lite/float16/1/pose_landmarker_lite.task' },
          runningMode: 'IMAGE',
          numPoses: 1
        });
      });
    }).then(function (created) {
      landmarker = created;
      return created;
    });
  }

  function readPose() {
    pose = null;
    if (!landmarker || !userImg) return;
    var result = landmarker.detect(userImg);
    var marks = result && result.landmarks && result.landmarks[0];
    if (!marks) return;
    var ls = marks[11], rs = marks[12], lh = marks[23], rh = marks[24];
    if (!ls || !rs || (ls.visibility || 0) < 0.4 || (rs.visibility || 0) < 0.4) return;
    var sw = userImg.naturalWidth;
    var sh = userImg.naturalHeight;
    var x1 = ls.x * sw, y1 = ls.y * sh, x2 = rs.x * sw, y2 = rs.y * sh;
    var shoulder = Math.hypot(x2 - x1, y2 - y1);
    var hx = lh && rh ? ((lh.x + rh.x) / 2) * sw : (x1 + x2) / 2;
    var hy = lh && rh ? ((lh.y + rh.y) / 2) * sh : ((y1 + y2) / 2) + shoulder * 1.35;
    pose = {
      cx: (x1 + x2) / 2,
      cy: (y1 + y2) / 2,
      angle: Math.atan2(y2 - y1, x2 - x1),
      shoulder: shoulder,
      torso: Math.max(shoulder * 1.15, Math.hypot(hx - (x1 + x2) / 2, hy - (y1 + y2) / 2))
    };
  }

  function paint() {
    if (!userImg || !garment) return;
    var maxW = 900;
    var view = Math.min(1, maxW / userImg.naturalWidth);
    canvas.width = Math.round(userImg.naturalWidth * view);
    canvas.height = Math.round(userImg.naturalHeight * view);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(userImg, 0, 0, canvas.width, canvas.height);
    var factor = Number(sizeInput.value) / 70;
    var dw, dh, cx, cy, angle;
    if (pose) {
      dw = pose.shoulder * view * 2.05 * factor;
      dh = Math.max(pose.torso * view * 1.35 * factor, dw * (garment.height / garment.width) * 0.92);
      cx = pose.cx * view + offsetX;
      cy = pose.cy * view + dh * 0.34 + offsetY;
      angle = pose.angle;
    } else {
      dw = canvas.width * 0.5 * factor;
      dh = dw * (garment.height / garment.width);
      cx = canvas.width / 2 + offsetX;
      cy = canvas.height * 0.34 + offsetY;
      angle = 0;
    }
    ctx.save();
    ctx.translate(cx, cy);
    ctx.rotate(angle);
    ctx.shadowColor = 'rgba(0,0,0,.28)';
    ctx.shadowBlur = 18 * view;
    ctx.shadowOffsetY = 8 * view;
    ctx.drawImage(garment, -dw / 2, -dh * 0.18, dw, dh);
    ctx.restore();
  }

  open.addEventListener('click', function () {
    modal.hidden = false;
  });
  modal.querySelector('.tryon-close').addEventListener('click', function () { modal.hidden = true; });
  modal.addEventListener('click', function (event) { if (event.target === modal) modal.hidden = true; });

  fileInput.addEventListener('change', function () {
    var file = fileInput.files && fileInput.files[0];
    if (!file) return;
    var src = productSrc();
    if (!src) return;
    offsetX = 0;
    offsetY = 0;
    hint.hidden = false;
    hint.textContent = 'Ürün omuzlara oturtuluyor...';
    Promise.all([loadImage(URL.createObjectURL(file), false), loadImage(src, true)]).then(function (images) {
      userImg = images[0];
      garment = knockWhite(images[1]);
      canvas.hidden = false;
      sizeLabel.hidden = false;
      return ensurePose().then(readPose).catch(function () { pose = null; });
    }).then(function () {
      hint.textContent = pose ? 'Ürün omuz ve gövdeye oturtuldu. Boyutla ve kaydırarak ince ayar yap.' : 'Vücut seçilemedi. Ürünü kaydırarak yerine getir.';
      paint();
    }).catch(function () {
      hint.hidden = false;
      hint.textContent = 'Fotoğraf işlenemedi. Başka bir fotoğrafla dene.';
    });
  });

  sizeInput.addEventListener('input', paint);

  function point(event) {
    var rect = canvas.getBoundingClientRect();
    var source = event.touches ? event.touches[0] : event;
    return {
      x: (source.clientX - rect.left) * (canvas.width / rect.width),
      y: (source.clientY - rect.top) * (canvas.height / rect.height)
    };
  }
  canvas.addEventListener('pointerdown', function (event) {
    if (!userImg) return;
    var p = point(event);
    drag = { x: p.x, y: p.y, ox: offsetX, oy: offsetY };
    canvas.setPointerCapture(event.pointerId);
  });
  canvas.addEventListener('pointermove', function (event) {
    if (!drag) return;
    var p = point(event);
    offsetX = drag.ox + (p.x - drag.x);
    offsetY = drag.oy + (p.y - drag.y);
    paint();
  });
  canvas.addEventListener('pointerup', function () { drag = null; });
})();
